<template>
  <deliveryProgress
    title="交付主页"
  />
</template>

<script>
import deliveryProgress from './deliveryProgress';

export default {
  name: 'homeDelivery',
  components: {
    deliveryProgress
  }
};
</script>

<style scoped lang="scss">
</style>
